import React, { Component } from "react"
import { getCustomColors } from "../utils/js/utils"
import Svg from "../_svgs/svg"
// eslint-disable-line no-unused-vars
import Emitter from "../../helpers/emitter"
import * as emits from "../../constants/emits"

import "./_message-tile.scss"

import "lazysizes"
import "lazysizes/plugins/attrchange/ls.attrchange"

class MessageTile extends Component {
  static defaultProps = {
    cover: false,
    modifier: "",
    themeClass: "",
    imageUrl: "",
    imageAltText: "",
    title: "",
    bodyText: "",
    link: "",
    linkText: "",
    iconName: "",
    backgroundColor: "",
    backgroundHoverColor: "",
    textColor: "",
    textHoverColor: "",
    modal: {},
  }

  handleClickLink(e) {
    if (this.props.clickHandler) {
      this.props.clickHandler()
    }
    if (this.props.modal && Object.keys(this.props.modal).length > 0) {
      e.preventDefault()
      Emitter.emit("*", {
        type: emits.REQUEST_CONTENT_MODAL_OPEN,
        modalJson: this.props.modal,
      })
    }
  }

  render() {
    const messageIconSnippet = (
      <div className="message-tile__icon">
        {" "}
        <Svg {...this.props} />{" "}
      </div>
    )
    const linkTextSnippet = <div className="shop-link">{this.props.linkText}</div>
    const imageSnippet = (
      <div className="message-tile__image" data-epi-property-name="Image">
        <img src={this.props.imageUrl} alt={this.props.imageAltText} />
      </div>
    )

    const style = getCustomColors(this.props)

    return (
      <a
        href={this.props.link}
        className={`message-tile ${this.props.cover ? "message-tile--cover" : this.props.modifier} ${this.props.themeClass}`}
        style={style}
        onClick={(e) => this.handleClickLink(e)}
      >
        {this.props.imageUrl && imageSnippet}
        {!this.props.cover && (
          <div className="message-tile__inner">
            {this.props.iconName && this.props.iconName !== "None" && messageIconSnippet}
            <h4 className="message-tile__headline" data-epi-property-name="Title">
              {this.props.title}
            </h4>
            <p className="message-tile__body" data-epi-property-name="BodyText">
              {this.props.bodyText}
            </p>
            {this.props.linkText && linkTextSnippet}
          </div>
        )}
      </a>
    )
  }
}

export default MessageTile
